module.exports = __webpack_public_path__ + "img/20180815_145911_039.211bcfe3.jpg";